export default "__VITE_ASSET__9aac8a85__"